/**
 * Inicializace react widgets.
 */

// import "react-widgets/lib/less/react-widgets.less";


import './reactWidgetsInit.less';
import './reactWidgetsInit.scss';

require('moment/locale/cs.js');
const Moment = require('moment');
const momentLocalizer = require('react-widgets/lib/localizers/moment');

momentLocalizer(Moment);
